module.exports = __webpack_public_path__ + "b6b48a1c074b7aad5132a83cdbb882d9.svg";